<template>
  <div>
    <h4>CTA</h4>

    <compact-localized-field
      v-model="newCta.disconnected"
      label="Disconnected"
      @input="emitUpdate"
    />

    <compact-localized-field
      v-model="newCta.connecting"
      label="Connecting"
      @input="emitUpdate"
    />

    <compact-localized-field
      v-model="newCta.connected"
      label="Connected"
      @input="emitUpdate"
    />
  </div>
</template>
<script>
  import CompactLocalizedField from "./CompactLocalizedField";

  export default {
    name: "LocalizedCTAForm",
    components: { CompactLocalizedField },
    props: {
      value: {
        type: Object,
        require: true,
        default() {
          return {
            disconnected: { en: "", uk: ""},
            connecting: { en: "", uk: ""},
            connected: { en: "", uk: ""},
          };
       }
      }
    },
    data() {
      return {
        newCta: {...this.$props.value}
      };
    },
    methods: {
      emitUpdate() {
        this.$emit("input", this.newCta);
      }
    }
  };
</script>
